module.exports = __webpack_public_path__ + "media/images/alerta_parada-88baaf31f4d34da1375eb7c2680838aa.jpg";